export default "assets/assets/35ee87f923824747c5650d20d1587d1a.gif";